import { EnvironmentConfig } from "~/modules/config";

export const getEnvironmentConfig = (): EnvironmentConfig => ({
    authServiceUrl: "https://iam.twilio.com/v1/Accounts",
    twilioServiceLoginUrl: "https://flex.twilio.com/admin",
    ...window.__TWILIO_FLEX_SDK__?.environmentConfig
});
